<template>
  <div id="ag-grid-lists">
    <div id="div-with-loading" class="vs-con-loading__container">
      <vs-tabs class="user-management-lists custom-vs-tabs slot-border-top">
        <vs-tab label="Users">
          <div class="tab-text">
            <UserList></UserList>
          </div>
        </vs-tab>

        <vs-tab label="Roles">
          <div class="tab-text">
            <RoleList></RoleList>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    <EditUser></EditUser>

    <EditRole></EditRole>
  </div>
</template>

<script>
import UserList from '@/components/ag-grid-tables/user-management/UserList.vue';
import RoleList from '@/components/ag-grid-tables/user-management/RoleList.vue';
import EditUser from '@/components/ag-grid-tables/user-management/EditUser.vue';
import EditRole from '@/components/ag-grid-tables/user-management/EditRole.vue';

export default {
  name: 'UserManagement',
  components: {
    UserList,
    RoleList,
    EditUser,
    EditRole
  }
}
</script>